import { Routes, Route, Navigate } from "react-router-dom";
import SignIn from "views/auth/SignIn";
import SignInPhone from "views/auth/SignInPhone";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";

export default function Auth() {
  document.documentElement.dir = "ltr";
  return (
    <div className="relative h-full min-h-screen w-full overflow-hidden bg-canvas">
      <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-brand-100/70 blur-3xl dark:bg-brand-500/15" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-64 w-64 rounded-full bg-navy-100/70 blur-3xl dark:bg-brand-500/10" />
      <FixedPlugin />
      <main className="relative z-10 mx-auto flex min-h-screen w-full max-w-[620px] items-center justify-center px-5 py-8 sm:py-10">
        <Routes>
          <Route path="sign-in" element={<SignIn />} />
          <Route path="sign-in-phone" element={<SignInPhone />} />
          <Route
            path="/"
            element={<Navigate to="/auth/sign-in-phone" replace />}
          />
        </Routes>
      </main>
    </div>
  );
}
